import React, { Component } from 'react';
import axios from 'axios'
import { Button, Card, Table } from 'react-bootstrap'
import { connect } from 'react-redux';

class AdminShipping extends Component {
    state = {
        shippingFormatted: [],

    }
    componentDidMount() {
        axios.get('/api/prices/shipping/get-all').then((resp) => {
            let shippingFormatted = this.state.shippingFormatted
            resp.data.shipping.forEach(option => {
                shippingFormatted.push({ 'name': option.name, 'cost': option.cost, '_id': option._id, max_x: option.max_x, max_y: option.max_y, max_z: option.max_z })
            })
            shippingFormatted.push({ 'name': '', 'cost': '', "_id": 0 })
            this.setState({ shippingFormatted: shippingFormatted, })
        })
    }
    updateShipping = (id, name, cost, max_x, max_y, max_z) => {
        axios.post('/api/prices/shipping/set', { id: id, name: name, cost: cost, max_x: max_x, max_y: max_y, max_z: max_z }).then((res) => {
        })

    }
    updateInput = (e, type, id) => {
        let shippingFormatted = this.state.shippingFormatted
        let idx = 0
        for (const option of shippingFormatted) {
            if (option._id == id) {
                break;
            }
            idx++
        }
        shippingFormatted[idx][type] = e.target.value
        this.setState({ 'shippingFormatted': shippingFormatted })
    }
    render() {
        let shipping = []
        this.state.shippingFormatted.forEach((option, index) => {
            shipping.push(
                <tr key={option._id ? option._id : "0"}>
                    <td onChange={(e) => this.updateInput(e, 'name', option._id)}><input placeholder={option.name} /></td>
                    <td onChange={(e) => this.updateInput(e, 'cost', option._id)}><input type="number" placeholder={option.cost}></input></td>
                    <td onChange={(e) => this.updateInput(e, 'max_x', option._id)}><input type="number" placeholder={option.max_x}></input></td>
                    <td onChange={(e) => this.updateInput(e, 'max_y', option._id)}><input type="number" placeholder={option.max_y}></input></td>
                    <td onChange={(e) => this.updateInput(e, 'max_z', option._id)}><input type="number" placeholder={option.max_z}></input></td>

                    <td>
                        <Button type='submit' onClick={() => this.updateShipping(option._id, option.name, option.cost, option.max_x, option.max_y, option.max_z)}>
                            Update
                        </Button>
                    </td>
                </tr>
            )
        })
        let darkmode = this.props.user ? this.props.user.darkmode : true

        return (
            <div>
                <Card style={{ margin: '30px' }}>

                    <Card.Header className={darkmode ? "darkmode-card-header" : "lightmode-card-header"} style={{ textAlign: 'center' }}>
                        shipping
                    </Card.Header>
                    <Card.Body className={darkmode ? "darkmode-card-content" : "lightmode-card-content"} style={{ 'margin': '0px' }} >
                        <Table style={{ 'margin': '0px' }} bordered>
                            <thead>
                                <tr className={darkmode ? "darkmode-card-header" : "lightmode-card-header"}>
                                    <th>Name</th>
                                    <th>Cost</th>
                                    <th>Max_x (mm)</th>
                                    <th>Max_y (mm)</th>
                                    <th>Max_z (mm)</th>
                                    <th>Update</th>

                                </tr>
                            </thead>
                            <tbody className={darkmode ? "darkmode-card-content" : "lightmode-card-content"}>
                                {shipping}
                            </tbody>
                        </Table>
                    </Card.Body>
       
                </Card>


            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}
function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminShipping);